export default __webpack_public_path__ + "static/media/codepen-01.b6c821c7.svg";